module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0a907e4555aebe1ddf4f650b73be0701.png";